import { createFileRoute } from '@tanstack/react-router';
import { PersonAttributesRoute } from './-route-wrappers';

/** The person profile's Attributes tab at its own URL (FPS-4208). */
function PersonAttributesIndexRoute() {
  const { personId } = Route.useParams();

  return <PersonAttributesRoute personId={personId} />;
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/people/$personId/attributes/')({
  component: PersonAttributesIndexRoute,
});
